import {
  Component,
  computed,
  effect,
  EventEmitter,
  forwardRef,
  inject,
  InjectionToken,
  input,
  Output,
  signal,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

export const CTR_SELECT_OPTION_GROUP = new InjectionToken<SelectOptionGroupComponent>('CtrSelectOptionGroup');

const SELECT_OPTION_GROUP_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => SelectOptionGroupComponent),
  multi: true,
};

type OnChange = (value: string | undefined | null) => void;
type OnTouched = () => void;

@Component({
  selector: 'ctr-select-option-group',
  imports: [],
  providers: [
    SELECT_OPTION_GROUP_VALUE_ACCESSOR,
    {
      provide: CTR_SELECT_OPTION_GROUP,
      useExisting: SelectOptionGroupComponent,
    },
  ],
  template: '<ng-content></ng-content>',
})
export class SelectOptionGroupComponent implements ControlValueAccessor {
  private onChange: OnChange | undefined;
  private onTouched: OnTouched | undefined;

  value = signal<string | undefined | null>('');

  constructor() {
    effect(() => {
      const value = this.value();
      this.onChange?.(value);
      this.onTouched?.();
    });
  }

  writeValue(obj: string): void {
    this.value.set(obj);
  }

  registerOnChange(fn: OnChange): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: OnTouched): void {
    this.onTouched = fn;
  }
}

@Component({
  selector: 'ctr-select-option',
  imports: [MatIconModule, MatRippleModule],
  templateUrl: './select-option.component.html',
  styleUrl: './select-option.component.scss',
})
export class SelectOptionComponent {
  @Output() action: EventEmitter<void> = new EventEmitter<void>();

  public subtitle = input<string | undefined | null>();
  public label = input<string | undefined | null>();
  public value = input<string | undefined | null>();
  public selected = input<boolean>();

  public checked = computed(() => {
    if (this.selectOptionGroup) {
      return this.selectOptionGroup.value() === this.value();
    }
    return this.selected();
  });

  hotelColor: string | undefined;

  selectOptionGroup: SelectOptionGroupComponent | undefined;

  constructor() {
    const selectOptionGroup = inject<SelectOptionGroupComponent>(CTR_SELECT_OPTION_GROUP, { optional: true });

    if (selectOptionGroup) {
      this.selectOptionGroup = selectOptionGroup;
    }
  }

  click() {
    this.action.emit();
    if (this.selectOptionGroup) {
      this.selectOptionGroup.value.set(this.value());
    }
  }
}
